import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import OwnerLogin from "@/pages/OwnerLogin";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Process the OAuth callback BEFORE any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/owner" element={<OwnerDashboard />} />
      <Route path="/owner/login" element={<OwnerLogin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <AppRouter />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}
